import { useState, useEffect } from 'react';
import content from '../content.json';

export default function Hero() {
  const [current, setCurrent] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const slides = content.hero.slides;
  const total = slides.length;
  const pub = process.env.PUBLIC_URL;

  useEffect(() => { const t = setTimeout(() => setLoaded(true), 100); return () => clearTimeout(t); }, []);
  useEffect(() => { const t = setTimeout(() => setCurrent((current + 1) % total), 5500); return () => clearTimeout(t); }, [current, total]);
  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const prev = () => setCurrent((current - 1 + total) % total);
  const next = () => setCurrent((current + 1) % total);

  return (
    <section id="home" style={{ position: 'relative', height: '100vh', minHeight: '600px', background: 'var(--black)', overflow: 'hidden' }}>

      {/* Slides con parallax */}
      {slides.map((slide, i) => (
        <div key={i} style={{
          position: 'absolute', inset: 0, zIndex: 0,
          opacity: i === current ? 1 : 0,
          transition: 'opacity 1.4s cubic-bezier(0.4,0,0.2,1)',
          transform: `translateY(${scrollY * 0.35}px) scale(1.1)`,
          willChange: 'transform',
          overflow: 'hidden',
        }}>
          {slide.image ? (
            <img
              src={`${pub}/${slide.image}`}
              alt={slide.alt || ''}
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }}
            />
          ) : (
            <div style={{ width: '100%', height: '100%', background: 'radial-gradient(ellipse at 30% 50%, rgba(229,0,60,0.08) 0%, transparent 70%)' }} />
          )}
        </div>
      ))}

      {/* Overlay gradiente */}
      <div style={{ position: 'absolute', inset: 0, zIndex: 1, background: 'linear-gradient(to bottom, rgba(13,13,13,0.3) 0%, rgba(13,13,13,0.1) 40%, rgba(13,13,13,0.7) 100%)' }} />

      {/* LOGHI in basso a sinistra */}
      <div style={{
        position: 'absolute', bottom: '48px', left: '40px', zIndex: 4,
        display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '20px',
        opacity: loaded ? 1 : 0,
        transform: loaded ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 1.2s ease 0.8s, transform 1.2s ease 0.8s',
      }}>
        <img src={`${pub}/rural-design-logo-sopra-Hero.svg`} alt="RUDE Rural Design Amiata 2026" style={{ height: '144px', width: 'auto' }} />
        <img src={`${pub}/Mercurio-logo-sopra-Hero.svg`} alt="Mercurio" style={{ height: '144px', width: 'auto' }} />
      </div>

      {/* LOGO Amiata in basso a destra */}
      <div style={{
        position: 'absolute', bottom: '48px', right: '40px', zIndex: 4,
        opacity: loaded ? 1 : 0,
        transform: loaded ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 1.2s ease 1s, transform 1.2s ease 1s',
      }}>
        <img src={`${pub}/Amiata-logo-sopra-Hero.svg`} alt="Amiata" style={{ height: '36px', width: 'auto', opacity: 0.85 }} />
      </div>

      {/* Frecce */}
      <button onClick={prev} style={{ position: 'absolute', left: '24px', top: '50%', transform: 'translateY(-50%)', zIndex: 3, background: 'none', border: 'none', cursor: 'none', color: 'var(--white)', fontSize: '40px', opacity: 0.4, transition: 'opacity 0.3s', padding: '16px' }}
        onMouseEnter={e => e.currentTarget.style.opacity = 1}
        onMouseLeave={e => e.currentTarget.style.opacity = 0.4}
      >‹</button>
      <button onClick={next} style={{ position: 'absolute', right: '24px', top: '50%', transform: 'translateY(-50%)', zIndex: 3, background: 'none', border: 'none', cursor: 'none', color: 'var(--white)', fontSize: '40px', opacity: 0.4, transition: 'opacity 0.3s', padding: '16px' }}
        onMouseEnter={e => e.currentTarget.style.opacity = 1}
        onMouseLeave={e => e.currentTarget.style.opacity = 0.4}
      >›</button>

      {/* Dots */}
      <div style={{ position: 'absolute', bottom: '36px', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '8px', zIndex: 3 }}>
        {slides.map((_, i) => (
          <button key={i} onClick={() => setCurrent(i)} style={{ width: i === current ? '32px' : '6px', height: '2px', background: i === current ? 'var(--red)' : 'rgba(255,255,255,0.25)', border: 'none', cursor: 'none', transition: 'all 0.4s ease', padding: 0 }} />
        ))}
      </div>

      {/* Scroll indicator */}
      <div style={{ position: 'absolute', bottom: '36px', right: '40px', zIndex: 3, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px', opacity: loaded ? 1 : 0, transition: 'opacity 1s ease 1.5s' }}>
        <div style={{ width: '1px', height: '60px', background: 'linear-gradient(to bottom, transparent, var(--red))', animation: 'scrollPulse 2s ease infinite' }} />
        <span style={{ fontFamily: 'var(--font-body)', fontSize: '9px', letterSpacing: '0.3em', color: 'var(--gray-mid)', textTransform: 'uppercase', writingMode: 'vertical-rl' }}>scroll</span>
      </div>

      <style>{`@keyframes scrollPulse { 0% { opacity:0; transform:scaleY(0); transform-origin:top; } 50% { opacity:1; } 100% { opacity:0; transform:scaleY(1); transform-origin:top; } }`}</style>
    </section>
  );
}
